"use strict";

var React = require("react");
var Router = require("react-router");
var Link = Router.Link;
var AuthStore     = require("./stores/AuthenticationStore");
var AuthActions   = require("./actions/AuthenticationActions");
var BankOverloardActions = require("./actions/BankOverloardActions");
var _ = require("underscore");
import { browserHistory } from 'react-router';

var Header = React.createClass({
    getInitialState() {
        var authState = AuthStore.getState();

        return {
            fullName: authState.first_name+" "+authState.last_name,
            profilePicture: ""
        };
    },
    componentDidMount() {
        AuthStore.listen(this.onChange);
    },
    componentWillUnmount() {
        AuthStore.unlisten(this.onChange);
    },
    onChange: function () {
        var newstate = this.getInitialState();
        this.setState(newstate);
    },
    logout: function() {
        AuthActions.logoutUser();
    },
    render: function(){
        return (
            <div id="header" data-spy="affix" data-offset-top="60">
                <div className="pull-left header-title">
                    <h2 className="pull-left">Búnaðarlisti</h2>
                </div>
                <div className="pull-right">
                    <div className="pull-right profile-image">
                        {this.state.profilePicture ? <img src={this.state.profilePicture} /> : ""}
                    </div>
                    <div className="pull-right">
                        <div className="profile-info">
                            <h5>{this.state.fullName}</h5>
                            <div className="profile-links">
                                <Link to="/profile" className="profile-link" id="profile">Prófíll</Link> - <a className="profile-link" id="logout" onClick={this.logout}>Skrá út</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = Header;



// WEBPACK FOOTER //
// ./app/scripts/Header.react.js